import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Mechanism } from './components/Mechanism';
import { Deliverables } from './components/Deliverables';
import { TargetAudience } from './components/TargetAudience';
import { HowItWorks } from './components/HowItWorks';
import { Timeline } from './components/Timeline';
import { FAQ } from './components/FAQ';
import { Pricing } from './components/Pricing';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const f = window as any;
      const n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      (window as any).fbq('init', '666521186552257');
      (window as any).fbq('track', 'PageView');
    }
  }, []);
  return <main className="min-h-screen bg-neutral-950 text-neutral-300 font-sans selection:bg-toxic selection:text-black" data-id="element-0">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=666521186552257&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
      <Hero data-id="element-3" />
      <Problem data-id="element-4" />
      <Mechanism data-id="element-5" />
      <Deliverables data-id="element-6" />
      <TargetAudience data-id="element-7" />
      <HowItWorks data-id="element-8" />
      <Timeline data-id="element-9" />
      <FAQ data-id="element-10" />
      <Pricing data-id="element-11" />
      <Footer data-id="element-12" />
    </main>;
}